import { useGetAllNotificationsQuery } from "AppQuries/notification/notification";
import TableTop from "Components/UI/TableTop";
import { loggedInUser } from "core/redux/slice/authSlice";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { DatePicker } from "antd";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { format, formatDistanceToNow } from "date-fns";
import Select from "react-select";
import { Bell } from "react-feather";
import { getNotificationURL } from "core/Operations/getNofiticationURL";
const { RangePicker } = DatePicker;

const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Readed" },
  { value: "", label: "All" },
];
const AllNotification = () => {
  const userData = useSelector(loggedInUser);

  const [queryParams, setQueryParams] = useState({
    companyCode: userData?.companyCode,
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
    userId: userData?.userID,
    status: true,
  });

  const { data: notifications, refetch: getNotifications } =
    useGetAllNotificationsQuery(queryParams);
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const columns = [
    {
      title: "Notification",
      dataIndex: "notification",
      // sorter: (a, b) => a.notification.localeCompare(b.notification),
    },
  ];
  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    notifications,
    searchColumns,
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>All Notifications</h4>
            <h6>View your all activities</h6>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <label className="form-label">Start Date – End Date</label>
                    <div className="form-group">
                      <RangePicker
                        className="form-control"
                        style={{ display: "flex" }}
                        onChange={(dates, dateStrings) => {
                          if (dates) {
                            updateQueryParams("fromDate", dateStrings[0]);
                            updateQueryParams("toDate", dateStrings[1]);
                          }
                        }}
                        defaultValue={[
                          dayjs(queryParams?.fromDate, "YYYY-MM-DD"),
                          dayjs(queryParams?.toDate, "YYYY-MM-DD"),
                        ]}
                        dateFormat="YYYY-MM-DD"
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        // disabledDate={disabledDate}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Type Name</label>
                      <Select
                        className="select"
                        options={statusOptions}
                        placeholder="Select Type Name"
                        value={
                          statusOptions?.find(
                            (option) => option.value === queryParams?.status,
                          ) || ""
                        }
                        onChange={(e) => {
                          updateQueryParams("status", e?.value);
                        }}
                        isClearable
                      />
                    </div>
                  </div>

                  <div className="col-lg-1 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">&nbsp;</label>
                      <Link
                        className="btn btn-filters ms-auto"
                        onClick={getNotifications}
                        type="button"
                      >
                        <i data-feather="search" className="feather-search" />
                        <>Filter</>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="activity">
              <div className="activity-box">
                <ul className="activity-list">
                  {filteredData?.length > 0 ? (
                    filteredData?.map((notification) => (
                      <li key={notification?.slno}>
                        <div className="activity-user">
                          <Link
                            to={getNotificationURL(notification?.type)}
                            title=""
                            data-toggle="tooltip"
                            // data-original-title=""
                          >
                            <Bell className="m-3" />
                          </Link>
                        </div>
                        <div className="activity-content">
                          <div className="timeline-content">
                            <Link
                              to={getNotificationURL(notification?.type)}
                              className="name"
                            >
                              {notification?.message}
                            </Link>{" "}
                            <span className="time">
                              {formatDistanceToNow(
                                new Date(notification?.createDate),
                                {
                                  addSuffix: true,
                                },
                              )}
                            </span>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <div className="text-center">No data found</div>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllNotification;
